import React from 'react';
import { Box, Typography, Button } from '@mui/material';
import Animation from './Animation';
import { Animations } from '../../Types/allTypes';
import { Link } from 'react-router-dom';


const UnderConstruction: React.FC = () => {
  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      textAlign="center"
      p={3}
    >
      <Animation size={{ width: 200, height: 200 }} animationData={Animations.UNDER_CONSTRUCTION} />
      <Typography variant="h4" color="error">
                Under Construction
            </Typography>
            <Typography variant="body1" style={{ margin: '20px 0' }}>
                This page is under construction. Please check back later.
            </Typography>
            <Button
                variant="contained"
                component={Link}
                to="/"
                color="primary"
            >
                Go Back to Home
            </Button>
    </Box>
  );
};

export default UnderConstruction;
